import vipUPic from '@/assets/images/vip/vip-u-pice.svg'
import vipUDui from '@/assets/images/vip/vip-u-dui.svg'
import crystal from '@/assets/images/vip/crystal.svg'
import vipUCuo from '@/assets/images/vip/vip-u-cuo.svg'
import vipUMemory from '@/assets/images/vip/vip-u-memory.svg'
import vipUPhoto from '@/assets/images/vip/vip-u-photo.svg'
import vipURole from '@/assets/images/vip/vip-u-role.svg'
import vipUModels from '@/assets/images/vip/vip-u-models.svg'
import vipUCheckIn from '@/assets/images/vip/vip-u-check.svg'
import vipUThought from '@/assets/images/vip/vip-u-thoughts.svg'
import vipUTransition from '@/assets/images/vip/vip-u-tr.svg'
import vipUAds from '@/assets/images/vip/vip-u-ad.svg'
import vipDui from '@/assets/images/vip/dui.svg'
import vipPlusPic from '@/assets/images/vip/vip-p-pice.svg'
import vipPlusDui from '@/assets/images/vip/vip-p-dui.svg'
import vipPlusMemory from '@/assets/images/vip/vip-p-memory.svg'
import vipPlusPhoto from '@/assets/images/vip/vip-p-photo.svg'
import vipPlusRole from '@/assets/images/vip/vip-p-role.svg'
import vipPlusModels from '@/assets/images/vip/vip-p-models.svg'
import vipPlusCheckIn from '@/assets/images/vip/vip-p-check.svg'
import vipPlusThought from '@/assets/images/vip/vip-p-thoughts.svg'
import vipPlusTransition from '@/assets/images/vip/vip-p-tr.svg'
import vipPlusAds from '@/assets/images/vip/vip-p-ad.svg'
import vipVPic from '@/assets/images/vip/vip-v-pice.svg'
import vipVDui from '@/assets/images/vip/vip-v-dui.svg'
import vipVCuo from '@/assets/images/vip/vip-v-cuo.svg'
import shijiaoPlus from '@/assets/images/vip/shijiao.svg'
import fenggePlus from '@/assets/images/vip/fengge.svg'

import fenggeU from '@/assets/images/vip/fengge-u.svg'
import shijiaoU from '@/assets/images/vip/shijiao-u.svg'

import vipVMemory from '@/assets/images/vip/vip-v-memory.svg'
import vipPhoto from '@/assets/images/vip/vip-v-photo.svg'
import vipRole from '@/assets/images/vip/vip-v-role.svg'
import vipModels from '@/assets/images/vip/vip-v-models.svg'
import vipCheckIn from '@/assets/images/vip/vip-v-check.svg'
import vipThought from '@/assets/images/vip/vip-v-thoughts.svg'
import vipTransition from '@/assets/images/vip/vip-v-tr.svg'
import vipAds from '@/assets/images/vip/vip-v-ad.svg'
import vipVThoughtU from '@/assets/images/vip/accelerator-u.svg'
import vipVThoughtP from '@/assets/images/vip/accelerator-p.webp'
import vipVideoP from '@/assets/images/mine/video-p.svg'
import vipVideoU from '@/assets/images/mine/video-u.svg'
import vipImageP from '@/assets/images/vip/wuxian_p.webp'
import vipImageU from '@/assets/images/vip/wuxian_u.webp'



export const vipBenefitList = (benefitsList: any) => {
  return [
    {
      titleImg: vipUCheckIn,
      title: 'Daily check-in',
      extraPlus: "+" + benefitsList?.plus?.benefitsList?.extraRewardsForCheckIn,
      extraUltra: "+" + benefitsList?.ultra?.benefitsList?.extraRewardsForCheckIn,
      crystalImg: crystal,
    },
    {
      extraCrystalImgPrice: benefitsList?.ultra?.benefitsList?.lowerChatPrice + ' gems',
      extraCrystalImgPriceUltra: benefitsList?.plus?.benefitsList?.lowerChatPrice + ' gems',
      titleImg: vipUPic,
      title: 'Cheaper Chat Price',
      ultra: benefitsList?.ultra?.benefitsList.lowerChatPrice,
      plus: benefitsList?.plus?.benefitsList.lowerChatPrice,
      crystalImg: crystal,
    },
    {
      extraCrystalImgPrice: benefitsList?.ultra?.benefitsList?.lowerCreateVideoPrice + ' gems',
      extraCrystalImgPriceUltra: benefitsList?.plus?.benefitsList?.lowerCreateVideoPrice + ' gems',
      titleImg: vipVideoU,
      title: 'Generate video prices',
      ultra: benefitsList?.ultra?.benefitsList.lowerCreateVideoPrice,
      plus: benefitsList?.plus?.benefitsList.lowerCreateVideoPrice,
      crystalImg: vipVideoU,
    },
    {
      titleImg: vipUPhoto,
      title: 'Image Generation Price',
      ultra: benefitsList?.ultra?.benefitsList.lowerCreateImagePrice,
      plus: benefitsList?.plus?.benefitsList.lowerCreateImagePrice,
      duiImg: '',
      crystalImg: crystal,
      cuoImg: '',
      extraCrystalImgPrice: benefitsList?.ultra?.benefitsList?.lowerCreateImagePrice + ' gems',
      extraCrystalImgPriceUltra: benefitsList?.plus?.benefitsList?.lowerCreateImagePrice + ' gems',
    },
    {
      titleImg: vipUMemory,
      title: 'Extented Memory',
      extentedMemory: '25X',
      extentedPMemory: '18X ',
      ultra: '10X',
      plus: '6X',
      duiImg: '',
      crystalImg: '',
      cuoImg: ''
    },
    {
      titleImg: vipVThoughtU,
      title: 'Quick Command',
      ultra: benefitsList?.ultra?.benefitsList.lowerCreateImagePrice,
      plus: benefitsList?.plus?.benefitsList.lowerCreateImagePrice,
      duiImg:vipImageU,
      crystalImg: crystal,
      cuoImg: '',
      // extraCrystalImgPrice: '∞',
      extraCrystalImgPriceUltra: benefitsList?.plus?.benefitsList?.quickReplyDay + '/day',
    },
    {
      titleImg: vipURole,
      title: 'Unlock All Characters',
      ultra: '',
      plus: '',
      duiImg: vipUDui,
      crystalImg: '',
      cuoImg: '',
      dui: vipDui,

    },
    {
      titleImg: vipUModels,
      title: 'Access All Models',
      ultra: '',
      plus: '',
      duiImg: vipUDui,
      crystalImg: '',
      cuoImg: '',
      dui: vipDui,

    },
    // {
    //   titleImg: vipUThought,
    //   title: 'Show Chain of Thought',
    //   ultra: '',
    //   plus: '',
    //   duiImg: vipUDui,
    //   crystalImg: '',
    //   cuoImg: vipUCuo,
    //   dui: vipDui,

    // },
    {
      titleImg: vipUTransition,
      title: 'Switch Chat Scenario',
      ultra: '',
      plus: '',
      duiImg: vipUDui,
      crystalImg: '',
      cuoImg: vipUCuo,
      dui: vipDui,

    },
    {
      titleImg: shijiaoU,
      title: 'Switch Chat Perspective',
      ultra: '',
      plus: '',
      duiImg: vipUDui,
      crystalImg: '',
      cuoImg: vipUCuo,
      dui: vipDui,

    },
    // {
    //   titleImg: fenggeU,
    //   title: 'Switch Chat Style',
    //   ultra: '',
    //   plus: '',
    //   duiImg: vipUDui,
    //   crystalImg: '',
    //   cuoImg: vipUCuo,
    //   dui: vipDui,
    // },
    // {
    //   titleImg: vipUAds,
    //   title: 'Ad-Free Experience',
    //   ultra: '',
    //   plus: '',
    //   duiImg: vipUDui,
    //   crystalImg: '',
    //   cuoImg: '',
    //   dui: vipDui,
    // }
  ]
}
export const vipPlusBenefitList = (benefitsList: any) => {
  return [
    {
      titleImg: vipPlusCheckIn,
      title: 'Daily check-in',
      extraPlus: '+' + benefitsList?.plus?.benefitsList?.extraRewardsForCheckIn,
      extraUltra: '+' + benefitsList?.ultra?.benefitsList?.extraRewardsForCheckIn,
      crystalImg: crystal,
    },
    {
      extraCrystalImgPrice: '+' + benefitsList?.ultra?.benefitsList?.lowerChatPrice + ' gems',
      extraCrystalImgPriceUltra: '+' + benefitsList?.plus?.benefitsList?.lowerChatPrice + ' gems',
      titleImg: vipPlusPic,
      title: 'Cheaper Chat Price',
      ultra: benefitsList?.ultra?.benefitsList.lowerChatPrice,
      plus: benefitsList?.plus?.benefitsList.lowerChatPrice,
      crystalImg: crystal,
    },
    {
      extraCrystalImgPrice: '+' + benefitsList?.ultra?.benefitsList?.lowerCreateVideoPrice + ' gems',
      extraCrystalImgPriceUltra: '+' + benefitsList?.plus?.benefitsList?.lowerCreateVideoPrice + ' gems',
      titleImg: vipVideoP,
      title: 'Generate video prices',
      ultra: benefitsList?.ultra?.benefitsList.lowerCreateVideoPrice,
      plus: benefitsList?.plus?.benefitsList.lowerCreateVideoPrice,
      crystalImg: vipVideoP,
    },
    {
      titleImg: vipPlusPhoto,
      title: 'Image Generation Price',
      ultra: benefitsList?.ultra?.benefitsList.lowerCreateImagePrice,
      plus: benefitsList?.plus?.benefitsList.lowerCreateImagePrice,
      duiImg: '',
      crystalImg: crystal,
      cuoImg: '',
      extraCrystalImgPrice: "+" + benefitsList?.ultra?.benefitsList?.lowerCreateImagePrice + ' gems',
      extraCrystalImgPriceUltra: '+' + benefitsList?.plus?.benefitsList?.lowerCreateImagePrice + ' gems',
    },
    {
      titleImg: vipPlusMemory,
      title: 'Extented Memory',
      extentedMemory: (benefitsList?.ultra?.benefitsList?.characterMemory) / 100 + 'X',
      extentedPMemory: (benefitsList?.plus?.benefitsList?.characterMemory) / 100 + 'X',
      ultra: '10X',
      plus: '6X',
      duiImg: '',
      crystalImg: '',
      cuoImg: ''
    },
    {
      titleImg: vipVThoughtP,
      title: 'Quick Command',
      ultra: benefitsList?.ultra?.benefitsList.lowerCreateImagePrice,
      plus: benefitsList?.plus?.benefitsList.lowerCreateImagePrice,
      dui: vipImageP,
      crystalImg: crystal,
      cuoImg: '',
      extraCrystalImgPrice: '',
      extraCrystalImgPriceUltra: benefitsList?.plus?.benefitsList?.quickReplyDay + '/day',
    },

    {
      titleImg: vipPlusRole,
      title: 'Unlock All Characters',
      ultra: '',
      plus: '',
      duiImg: vipPlusDui,
      crystalImg: '',
      cuoImg: '',
      dui: vipDui,
      pulsDui: vipPlusDui

    },
    {
      titleImg: vipPlusModels,
      title: 'Access All Models',
      ultra: '',
      plus: '',
      duiImg: vipPlusDui,
      crystalImg: '',
      cuoImg: '',
      dui: vipDui,
      pulsDui: vipPlusDui

    },
    // {
    //   titleImg: vipPlusThought,
    //   title: 'Show Chain of Thought',
    //   ultra: '',
    //   plus: '',
    //   duiImg: vipPlusDui,
    //   crystalImg: '',
    //   cuoImg: vipUCuo,
    //   dui: vipDui,
    //   pulsDui: vipPlusDui

    // },
    {
      titleImg: vipPlusTransition,
      title: 'Switch Chat Scenario',
      ultra: '',
      plus: '',
      duiImg: vipPlusDui,
      crystalImg: '',
      cuoImg: vipUCuo,
      dui: vipDui,
      pulsDui: vipPlusDui

    },
    {
      titleImg: shijiaoPlus,
      title: 'Switch Chat Perspective',
      ultra: '',
      plus: '',
      duiImg: vipUDui,
      crystalImg: '',
      cuoImg: vipUCuo,
      dui: vipDui,
      pulsDui: vipPlusDui

    },
    // {
    //   titleImg: fenggePlus,
    //   title: 'Switch Chat Style',
    //   ultra: '',
    //   plus: '',
    //   duiImg: vipUDui,
    //   crystalImg: '',
    //   cuoImg: vipUCuo,
    //   dui: vipDui,
    //   pulsDui: vipPlusDui
    // },
    // {
    //   titleImg: vipPlusAds,
    //   title: 'Ad-Free Experience',
    //   ultra: '',
    //   plus: '',
    //   duiImg: vipPlusDui,
    //   crystalImg: '',
    //   cuoImg: '',
    //   dui: vipDui,
    //   pulsDui: vipPlusDui
    // }
  ]
}
export const vipBenefitListTwo = (benefitsList: any) => {
  return [
    {
      titleImg: vipVPic,
      title: 'Cheaper Chat Price',
      ultra: benefitsList?.ultra?.benefitsList.lowerChatPrice,
      plus: benefitsList?.plus?.benefitsList.lowerChatPrice,
      vip: benefitsList?.vip?.benefitsList.lowerChatPrice,
      duiImg: '',
      crystalImg: crystal,
      cuoImg: ''
    },
    {
      titleImg: vipVMemory,
      title: 'Extented Memory',
      ultra: '10X',
      plus: '6X',
      vip: '4X',
      duiImg: '',
      crystalImg: '',
      cuoImg: ''
    },
    {
      titleImg: vipPhoto,
      title: 'Image Generation Price',
      ultra: benefitsList?.ultra?.benefitsList.lowerCreateImagePrice,
      plus: benefitsList?.plus?.benefitsList.lowerCreateImagePrice,
      vip: benefitsList?.vip?.benefitsList.lowerCreateImagePrice,
      duiImg: '',
      crystalImg: crystal,
      cuoImg: ''
    },
    {
      titleImg: vipRole,
      title: 'Unlock All Characters',
      ultra: '',
      plus: '',
      vip: '',
      duiImg: vipVDui,
      crystalImg: '',
      cuoImg: '',
      dui: vipDui
    },
    {
      titleImg: vipModels,
      title: 'Access All Models',
      ultra: '',
      plus: '',
      vip: '',
      duiImg: vipVDui,
      crystalImg: '',
      cuoImg: '',
      dui: vipDui
    },
    {
      titleImg: vipCheckIn,
      title: 'Unlimited Check-ins',
      ultra: '',
      plus: '',
      vip: '',
      duiImg: vipVDui,
      crystalImg: '',
      cuoImg: '',
      dui: vipDui
    },
    // {
    //   titleImg: vipThought,
    //   title: 'Show Chain of Thought',
    //   ultra: '',
    //   plus: '',
    //   vip: '',
    //   duiImg: vipVDui,
    //   crystalImg: '',
    //   cuoImg: vipVCuo,
    //   dui: vipDui
    // },
    {
      titleImg: vipTransition,
      title: 'Switch Chat Scenario',
      ultra: '',
      plus: '',
      vip: '',
      duiImg: vipVDui,
      crystalImg: '',
      cuoImg: vipVCuo,
      dui: vipDui
    },

  ]
}
